// Components/Core/InfoTooltip.jsx
import React, { useState } from "react";
import { Tooltip, IconButton, ClickAwayListener } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const InfoTooltip = ({ text, placement = "top" }) => {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipToggle = () => {
    setOpen(!open);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Tooltip
        title={text}
        placement={placement}
        arrow
        open={open}
        onClose={handleTooltipClose}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        PopperProps={{
          sx: {
            "& .MuiTooltip-tooltip": {
              backgroundColor: "#053251",
              color: "#fff",
              fontSize: "13px",
              fontFamily: "iran-sans, MyPersianFont, sans-serif",
              padding: "10px 14px",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              maxWidth: "300px",
            },
            "& .MuiTooltip-arrow": {
              color: "#053251",
            },
          },
        }}
      >
        <IconButton
          onClick={handleTooltipToggle}
          size="small"
          sx={{
            padding: "2px",
            marginRight: "6px",
            color: "#7cc890",
            "&:hover": {
              backgroundColor: "rgba(124, 200, 144, 0.1)",
            },
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: "18px" }} />
        </IconButton>
      </Tooltip>
    </ClickAwayListener>
  );
};

export default InfoTooltip;
